export function getVid() {
  let v = localStorage.getItem("rg_vid");
  if (!v) {
    v = Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("rg_vid", v);
  }
  return v;
}
